import { useState } from 'react'
import { InventoryLocation } from 'inventory-web'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
	EuiText,
} from '@equipmentshare/ds2'

import useSetDefaultInventoryLocation from '../../../effects/setDefaultInventoryLocation'

export type SetDefaultInventoryLocationModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	inventoryLocation: InventoryLocation,
	updateAfterEdit: ( updatedInventoryLocation: InventoryLocation, clearOtherDefaults?: boolean ) => void,
}

export default function SetDefaultInventoryLocationModal( { onCancel, onSuccess, inventoryLocation, updateAfterEdit }: SetDefaultInventoryLocationModalProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const setDefault = useSetDefaultInventoryLocation( updateAfterEdit )

	const handleCancel = () => {
		heapEvent( 'Inventory - Set Default Store Modal - Click - Cancel', {} )
		onCancel()
	}
	const handleSubmit = async() => {
		setIsSaving( true )
		heapEvent( 'Inventory - Set Default Store Modal - Click - Set default', {} )
		try {
			await setDefault( inventoryLocation.id )
			onSuccess()
		} catch ( e: unknown ) {
			setIsSaving( false )
		}
	}

	return (
		<>
			<EuiModalBody>
				<EuiText>
					The main inventory will be used when the &quot;{inventoryLocation.branch.name}&quot; branch is selected in other T3 applications that use this inventory system.
				</EuiText>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Set as main inventory
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
